export { default as DocumentComponent } from './DocumentComponent';
